import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import {
  Grid2,
  Button,
  MenuItem,
  Select,
  Checkbox,
  Typography,
  Input,
  FilledInput,
  Chip,
  Tooltip,
  useTheme,
  useMediaQuery,
  Box,
  SnackbarContent,
  IconButton,
} from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import {
  useActiveJobDropDownQuery,
  useGetCandidateDetailMutation,
  useGetEmailDropdownQuery,
  useGetTechnologiesMutation,
} from "../../redux/candidateprofiles/candidateprofiles.api";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MUIButton from "../../reusable_components/components/MUIButton";
import { useSelector } from "react-redux";
import "./CandidateProfiles.css";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker";
import dayjs from "dayjs";
import {
  Link,
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Controller, get, useForm } from "react-hook-form";
import * as Yup from "yup";
import DescriptionIcon from "@mui/icons-material/Description";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import WestIcon from "@mui/icons-material/West";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DoneIcon from "@mui/icons-material/Done";
import Dropdown from "../../reusable_components/components/Dropdown";
import UploadCloudIcon from "../../assets/Icons/UploadCloudIcon";
import DocumentLoader from "../../reusable_components/components/DocumentLoader";
import Loader from "../../reusable_components/components/Loader";
import ClearIcon from "@mui/icons-material/Clear";
import { use } from "react";

const AddCandidate = () => {
  const { Snackbar } = useContext(SnackbarContext);
  const navigate = useNavigate();

  const location = useLocation();
  const { isReferrals } = location?.state || false;
  const [isCost, setIsCost] = useState(false);
  const [openCandidateStatus, setOpenCandidateStatus] = useState(false);
  const [openTechnologies, setOpenTechnologies] = useState(false);
  const [openEditCanStatus, setOpenEditCanStatus] = useState(false);
  const [openCurrencyType, setOpenCurrencyType] = useState(false);
  const [isExactNoticeDate, setIsExactNoticeDate] = useState(false);
  const [initialLastWorkingDay, setInitialLastWorkingDay] = useState(null);

  const currencyOptions = [
    { id: "INR", label: "INR" },
    { id: "USD", label: "USD" },
    { id: "AED", label: "AED" },
  ];


  const { Profile } = useSelector((state) => state.common);
  const id = Profile?.profile?.roleId;
  const role = Profile?.profile?.role;
  const emailId = Profile?.profile?.emailId;

  const params = useParams();
  const theme = useTheme();
  const isSmallcreen = useMediaQuery(theme.breakpoints.down("md"));

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .required("First Name is required")
      .matches(
        /^[A-Za-z]+(?: [A-Za-z]+)*$/,
        "First Name must contain only letters and single spaces"
      ),
    mobile: Yup.string()
      .required("Contact number is required")
      .min(10, "Contact number should be at least 10 digits")
      .matches(/^\+?[0-9]+$/, "Contact number should contain only numbers"),
    email: Yup.string()
      .email("Enter valid email")
      .required("Please enter the email")
      .test("Enter valid email", "Enter valid email", (value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(value);
      }),
    currencyType: Yup.string().required("Currency is required"),
    cctcInLakhs: Yup.number()
      .required("CCTC is required")
      .typeError("CCTC is required"),

    noticePeriodInMonths: isExactNoticeDate === false ? Yup.string()
      .required("Notice Period is required")
      .matches(/^([0-9]+|\d{4}-\d{2}-\d{2})$/, "Accept only positive numbers or valid date") : Yup.mixed().nullable().notRequired(),

    // currentOrganization: Yup.string()
    //   .required("Current Organization  is required")
    //   .matches(
    //     /^[A-Za-z0-9/&]+(?: [A-Za-z0-9/&]+)*$/,
    //     "Current Organization  should contain only letters"
    //   )
    //   .min(3, "Current Organization  must be at least 3 characters"),

    lastName: Yup.string()
      .required("Last Name is required")
      .matches(/^[A-Za-z]+(?: [A-Za-z]+)*$/, "must only contain letters"),
    ectcInLakhs: Yup.number()
      .required(" ECTC is required")
      .typeError("ECTC is required"),

    address: Yup.string()
      .required("Location is required")
      .matches(/^[A-Za-z]+(?: [A-Za-z]+)*$/, "Must contain letters")
      .min(3, "Location must be at least 3 characters"),
    // submittedBy: Yup.string().required("Email is required"),
    submittedBy:
      role === "recruiter"
        ? Yup.string()
        : Yup.string().required("Email is required"),

    remarks: Yup.string()
      .required("Remark is required")
      // .matches(/^[A-Za-z]+(?: [A-Za-z]+)*$/, "Remarks should contain only letters")
      .min(10, "Remarks must be at least 10 characters"),
    alternateNumber: Yup.string()
      .notRequired()
      .test(
        "valid-and-different-number",
        "Alternate number must be exactly 10 digits and different from contact number",
        function (value) {
          const mobile = this.resolve(Yup.ref("mobile"));
          if (!value) return true; // allow empty
          const isValidLength = /^[0-9]{10}$/.test(value);
          return isValidLength && value !== mobile;
        }
      ),
    alternateEmail: Yup.string()
      .nullable()
      .test("Enter Valid Email", "Enter Valid Email", (value) => {
        if (!value) return true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(value);
      })
      .notOneOf(
        [Yup.ref("email"), null],
        "Alternate Email should not be the same as email"
      ),
    jobPostion: Yup.string()
      .nullable()
      .notRequired(),
    // .transform((value) => (value?.trim() === "" ? null : value))
    // .test(
    //   "validation",
    //   "Position must be at least 3 characters and contain only letters, commas, #, ., /, or +",
    //   (value) =>
    //     !value ||
    //     (value.length >= 3 &&
    //       /^[A-Za-z\,\#\.\/+]+(?: [A-Za-z\,\#\.\/+]+)*$/.test(value))
    // ),
    candidateStatus: Yup.string().required("Candidate status is required"),
    totalExperience: Yup.string()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      )
      .nullable()
      .notRequired()
      .min(0, "Total experience must be greater than zero"),
    releventExperience: Yup.string()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      )
      .nullable()
      .notRequired()
      .min(0, "Relevent experience must be greater than zero"),
    candidateType: Yup.string().required("Candidate type is required"),
    lastWorkingDay: isExactNoticeDate ? Yup.date().typeError('Invalid date').required('Last working day is required') : Yup.mixed().nullable().notRequired()

  });

  const resolver = yupResolver(validationSchema);

  const {
    control,
    handleSubmit,
    reset,
    trigger,
    clearErrors,
    setValue,
    formState: { errors },
    watch,
  } = useForm({
    resolver,
    mode: "onChange",
    defaultValues: {
      firstName: "",
      mobile: "",
      email: "",
      currencyType: "INR",
      cctcInLakhs: "",
      noticePeriodInMonths: "",
      currentOrganization: "",
      lastName: "",
      ectcInLakhs: "",
      address: "",
      submittedBy: emailId,
      remarks: "",
      alternateNumber: "",
      alternateEmail: "",
      jobPostion: "",
      candidateStatus: "",
      releventExperience: "",
      totalExperience: "",
      candidateType: "",

    },
  });

  const { data: getDropdownDatas } = useGetEmailDropdownQuery();
  const [Technologies] = useGetTechnologiesMutation();
  const [viewCandidate, { data: getCandidateDetail }] =
    useGetCandidateDetailMutation();
  const { data: getActiveJobsDropdown } = useActiveJobDropDownQuery();

  const [selectedEmail, setSelectedEmail] = useState("");
  const [technologyKeywords, setTechnologyKeywords] = useState([]);
  const [selectedKeywordIds, setSelectedKeywordIds] = useState([]);
  const [selectedKeywords, setSelectedKeywords] = useState([]);

  const selectRef = useRef();
  const [openSelect, setOpenSelect] = useState(false); // manually control open state

  const [files, setFiles] = useState([]);
  const formData = new FormData();

  // payload properties

  const [alternateMobile, setAlternateMobile] = useState("");
  const [alternateEmail, setAlternateEmail] = useState("");
  const [totalExperience, setTotalExperience] = useState("");
  const [releventExperience, setReleventExperience] = useState("");
  const [filePath, setFilePath] = useState(null);
  const [fileExtension, setFileExtension] = useState("");
  const [statusId, setStatusId] = useState("");
  const [reasonForReject, setReasonForReject] = useState("");
  const [reasonError, setReasonError] = useState("");
  const [statusError, setStatusError] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [showOverAllLoader, setShowOverAllLoader] = useState(false);
  const [openPostionType, setOpenPostionType] = useState(false);


  const [isFile, setIsFile] = useState(false);

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setStatusId(value);
    setStatusError("");
  };

  const hanldeReasonForReject = (e) => {
    const value = e.target.value;
    setReasonForReject(value);
    setReasonError("");
  };

  const handleTotalExperience = (e) => {
    setTotalExperience(e.target.value);
  };

  const handleAlternateEmail = (e) => {
    setAlternateEmail(e.target.value);
  };

  const handleAlternateMobile = (e) => {
    setAlternateMobile(e.target.value);
  };

  const handleReleventExperience = (e) => {
    setReleventExperience(e.target.value);
  };

  const handleNavigateBack = () => {
    // if (isReferrals === true) {
    //     navigate('/referrals')
    // } else {
    //     navigate('/candidateprofile')
    // }
    navigate(-1);
  };
  // dialog box properties...
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    setIsFile(true);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const type = watch("rewardType");
  const canStatus = watch("candidateStatus")

  useEffect(() => {
    if (type === 1) {
      setIsCost(true);
    } else {
      setIsCost(false);
    }
  }, [watch, type]);

  const handleFileChange = async (e) => {
    const newFiles = Array.from(e.target.files); // Get uploaded files
    setFiles((prevFiles) => [...prevFiles, ...newFiles]); // Update state

    if (newFiles.length > 0) {
      // Prepare formData
      const formData = new FormData();
      newFiles.forEach((file) => {
        formData.append("file", file); // Append each file to formData
      });

      try {
        // Call the API
        setShowOverAllLoader(true);
        const response = await fetch(
          // `https://dev-or.g-axis.in/profileparsing`,
          `${window.REACT_APP_BASE_URL}profileParsing/upload`,
          {
            method: "POST",
            body: formData,
            // Content-Type is automatically set when using FormData
          }
        );
        setShowOverAllLoader(false);
        if (response?.ok) {
          const result = await response.json();
          if (editId) {
            const defaultValues = {
              firstName: result?.first_name,
              lastName: result?.last_name,
              mobile: result?.contact_number,
              alternateMobile: result?.alterate_number,
              email: result?.email,
              alternateEmail: result?.alternateEmail,
              address: result?.location,
              status: result?.status,
              currencyType: result?.currencyType || "INR",
              cctcInLakhs: result?.current_ctc,
              ectcInLakhs: result?.expected_ctc,
              noticePeriodInMonths: result?.notice_period,
              lastWorkingDay: result?.lastWorkingDay || null,
              currentOrganization: result?.current_organisation,
              totalExperience: result?.total_experience,
              releventExperience: result?.relevant_experirence,
              remarks: result?.remarks,
              submittedBy: localStorage.getItem("submittedBy"),
              technologies: result?.technologies,
              files: result?.cvPath,
              alternateNumber: result?.alternateMobile,
              feedBack: result?.profileFeedBack,
              candidateStatus: result?.candidateStatus,
            };
            reset({
              ...defaultValues,
            });
            setAlternateEmail(defaultValues?.alternateEmail);
            setTotalExperience(defaultValues?.totalExperience);
            setReleventExperience(defaultValues?.releventExperience);
            const filePath = defaultValues?.files;
            const extension = filePath
              ?.substring(filePath?.lastIndexOf(".") + 1)
              ?.toLowerCase();
            setFilePath(filePath);
            setFileExtension(extension);

            const techSkill = defaultValues?.technologies;
            const preselectedIds = technologyKeywords
              .filter((item) => techSkill.includes(item.keywordName))
              .map((item) => item.KeywordId);

            setSelectedKeywordIds(preselectedIds);
          } else {
            const defaultValues = {
              firstName: result?.first_name,
              lastName: result?.last_name,
              mobile: result?.contact_number,
              alternateMobile: result?.alterate_number,
              email: result?.email,
              alternateEmail: result?.alternateEmail,
              address: result?.location,
              status: result?.status,
              currencyType: result?.currencyType || "INR",
              cctcInLakhs: result?.current_ctc,
              ectcInLakhs: result?.expected_ctc,
              noticePeriodInMonths: result?.notice_period,
              lastWorkingDay: result?.lastWorkingDay,
              currentOrganization: result?.current_organisation,
              totalExperience: result?.total_experience,
              releventExperience: result?.relevant_experirence,
              remarks: result?.remarks,
              submittedBy: result?.submittedBy,
              technologies: result?.technologies,
              files: result?.cvPath,
              alternateNumber: result?.alternateMobile,
              feedBack: result?.profileFeedBack,
              candidateStatus: result?.candidateStatus,
            };
            reset({
              ...defaultValues,
            });
            setAlternateEmail(defaultValues?.alternateEmail);
            setTotalExperience(defaultValues?.totalExperience);
            setReleventExperience(defaultValues?.releventExperience);
            const filePath = defaultValues?.files;
            const extension = filePath
              ?.substring(filePath?.lastIndexOf(".") + 1)
              ?.toLowerCase();
            setFilePath(filePath);
            setFileExtension(extension);

            const techSkill = defaultValues?.technologies;
            const preselectedIds = technologyKeywords
              .filter((item) => techSkill.includes(item.keywordName))
              .map((item) => item.KeywordId);

            setSelectedKeywordIds(preselectedIds);
          }
        } else {
          console.error("Error:", response.statusText);
          setShowOverAllLoader(false);
        }
      } catch (error) {
        console.error("Fetch error:", error);
        setShowOverAllLoader(false);
      }
    }
  };

  const selectTechnologies = async () => {
    try {
      const payload = {
        keywordName: "",
        page: 0,
        size: 4000,
      };
      const response = await Technologies(payload).unwrap();

      setTechnologyKeywords(response?.response);
    } catch (error) {
      Snackbar("Network error", "error");
    }
  };

  const handleCheckboxChange = (e) => {
    const value = e.target.value;
    setSelectedKeywordIds(value);
    setIstech(false)
  };

  useEffect(() => {
    const Keywords = technologyKeywords?.filter((keyword) =>
      selectedKeywordIds?.includes(keyword?.KeywordId)
    );
    setSelectedKeywords(Keywords);
    if (files.length > 0) {
      setIsFile(true);
    } else {
      setIsFile(false);
    }
  }, [selectedKeywordIds, files]);

  const [istech, setIstech] = useState(false);
  const [isUploadResume, setIsUploadResume] = useState(false);

  const onSubmit = async (data) => {
    if (!editId) {
      if (selectedKeywordIds.length === 0) {
        setIstech(true);
        // setIsUploadResume(true)
      } else {
        try {
          if (!editId) {
            const payload = {
              profileId: "",
              firstName: data?.firstName,
              lastName: data?.lastName,
              mobile: data?.mobile,
              alternateMobile: data?.alternateNumber,
              email: data?.email,
              alternateEmail: data?.alternateEmail,
              address: data?.address,
              status: "Active",
              currencyType: data?.currencyType,
              cctcInLakhs: String(data?.cctcInLakhs),
              ectcInLakhs: String(data?.ectcInLakhs),
              noticePeriodInMonths: data?.noticePeriodInMonths,
              lastWorkingDay: data?.lastWorkingDay ? dayjs(data?.lastWorkingDay).format('DD-MM-YYYY') : null,
              currentOrganization: data?.currentOrganization,
              totalExperience: String(data?.totalExperience),
              releventExperience: String(data?.releventExperience),
              remarks: data?.remarks,
              submittedBy: data?.submittedBy || emailId,
              technologies: selectedKeywordIds?.filter((item) => item !== undefined),
              userRole: id,
              referralPosition: data?.jobPostion,
              candidateStatus: data?.candidateStatus,
              candidateType: data?.candidateType,
            };

            const lastIndex = files?.length - 1;

            // files?.forEach((file) => {
            //     formData.append('file', file);
            // });
            formData.append("file", files[lastIndex]);
            formData.append("data", JSON.stringify(payload));

            const token = localStorage.getItem("token");

            setShowOverAllLoader(true);
            const response = await fetch(
              `${window.REACT_APP_BASE_URL}saveCandidateDetails`,
              {
                method: "POST",
                body: formData,
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            setShowOverAllLoader(false);

            if (response?.ok) {
              const errorData = await response.json();
              if (errorData?.data?.error_message) {
                Snackbar(errorData?.data?.error_message, "error");
              } else {
                Snackbar("Profile saved successfully", "success");
                navigate(isReferrals ? "/referrals" : "/candidateprofile");
              }
            }
          }
        } catch (error) {
          Snackbar("Network error", "error");
        }
      }
    } else {
      try {
        if (!statusId) {
          setStatusError("Status is required."); // Set error for missing status
          return; // Prevent further execution
        }
        if (statusId === "Inactive" && !reasonForReject) {
          setReasonError("Reason for Rejection is required.");
          return; // Prevent further execution
        }
        const payload = {
          profileId: editId,
          firstName: data?.firstName,
          lastName: data?.lastName,
          mobile: data?.mobile,
          alternateMobile: data?.alternateNumber,
          email: data?.email,
          alternateEmail: data?.alternateEmail,
          address: data?.address,
          status: statusId,
          currencyType: data?.currencyType,
          cctcInLakhs: String(data?.cctcInLakhs),
          ectcInLakhs: String(data?.ectcInLakhs),
          noticePeriodInMonths: data?.noticePeriodInMonths,
          lastWorkingDay: data?.lastWorkingDay ? dayjs(data?.lastWorkingDay).format('DD-MM-YYYY') : null,
          currentOrganization: data?.currentOrganization,
          totalExperience: String(data?.totalExperience),
          releventExperience: String(data?.releventExperience),
          remarks: data?.remarks,
          submittedBy: data?.submittedBy || emailId,
          technologies: selectedKeywordIds?.filter((item) => item !== undefined),
          userRole: id,
          isFile: isFile,
          feedBack: statusId === "Inactive" ? reasonForReject : null,
          referralPosition: data?.jobPostion,
          candidateStatus: data?.candidateStatus,
          candidateType: data?.candidateType,
        };

        const formData = new FormData();
        const lastIndex = files?.length - 1;

        // files?.forEach((file) => {
        //     formData.append('file', file);
        // });
        formData.append("file", files[lastIndex]);
        formData.append("data", JSON.stringify(payload));

        const token = localStorage.getItem("token");
        setShowOverAllLoader(true);
        const response = await fetch(
          `${window.REACT_APP_BASE_URL}saveCandidateDetails`,
          {
            method: "POST",
            body: formData,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response?.ok) {
          const errorData = await response.json();
          setShowOverAllLoader(false);
          if (errorData?.data?.error_message) {
            Snackbar(errorData?.data?.error_message, "error");
          } else {
            Snackbar("Profile updated successfully", "success");
            navigate(isReferrals ? "/referrals" : "/candidateprofile");
          }
        }
      } catch (error) {
        Snackbar("Network error", "error");
      }
    }
  };

  const editId = +params?.id;

  useEffect(() => {
    if (editId) {
      const payload = {
        profileId: editId,
      };
      viewCandidate(payload);
    }
    selectTechnologies();
  }, [editId, viewCandidate]);

  useEffect(() => {
    if (getCandidateDetail) {
      const defaultValues = {
        firstName: getCandidateDetail?.response?.firstName,
        lastName: getCandidateDetail?.response?.lastName,
        mobile: getCandidateDetail?.response?.mobile,
        alternateMobile: getCandidateDetail?.response?.alternateMobile,
        email: getCandidateDetail?.response?.email,
        alternateEmail: getCandidateDetail?.response?.alternateEmail,
        address: getCandidateDetail?.response?.address,
        status: getCandidateDetail?.response?.status,
        currencyType: getCandidateDetail?.response?.currencyType || "INR",
        cctcInLakhs: getCandidateDetail?.response?.candidateCctc,
        ectcInLakhs: getCandidateDetail?.response?.candidateEctc,
        noticePeriodInMonths:
          getCandidateDetail?.response?.noticePeriodInMonths,
        lastWorkingDay: getCandidateDetail?.response?.lastWorkingDate || null,
        currentOrganization: getCandidateDetail?.response?.currentOrganization,
        totalExperience: getCandidateDetail?.response?.totalExperience,
        releventExperience: getCandidateDetail?.response?.releventExperience,
        remarks: getCandidateDetail?.response?.remarks,
        submittedBy: getCandidateDetail?.response?.submittedBy,
        technologies: getCandidateDetail?.response?.technologies,
        files: getCandidateDetail?.response?.cvPath,
        alternateNumber: getCandidateDetail?.response?.alternateMobile,
        profileFeedBack: getCandidateDetail?.response?.feedBack,
        jobPostion: getCandidateDetail?.response?.referralPosition,
        candidateStatus:
          getCandidateDetail?.response?.candidateStatus === null
            ? ""
            : getCandidateDetail?.response?.candidateStatus,
        candidateType: getCandidateDetail?.response?.candidateType,
      };
      reset({
        ...defaultValues,
      });
      setAlternateEmail(defaultValues?.alternateEmail);
      setReasonForReject(defaultValues?.profileFeedBack);
      setStatusId(defaultValues?.status);
      // setAlternateMobile(defaultValues?.alternateMobile)
      setTotalExperience(defaultValues?.totalExperience);
      setReleventExperience(defaultValues?.releventExperience);
      if (defaultValues?.lastWorkingDay) {
        setInitialLastWorkingDay(defaultValues.lastWorkingDay);
        setIsExactNoticeDate(true);
      }
      const filePath = defaultValues?.files;
      const extension = filePath
        ?.substring(filePath?.lastIndexOf(".") + 1)
        ?.toLowerCase();
      setFilePath(filePath);
      setFileExtension(extension);
      localStorage.setItem(
        "submittedBy",
        getCandidateDetail?.response?.submittedBy
      );

      const tech = defaultValues?.technologies;
      const filteredTech = tech?.filter((item) => item?.hasSelected);
      setSelectedKeywords(filteredTech);

      const keywordIds = filteredTech?.map((item) => item?.keywordId);
      setSelectedKeywordIds((prev) => [...prev, ...keywordIds]);
    }
  }, [getCandidateDetail, reset]);

  // After isExactNoticeDate becomes true, the Controller for lastWorkingDay
  // mounts for the first time. Only then can setValue properly inject the
  // backend date into the registered field.
  useEffect(() => {
    if (isExactNoticeDate && initialLastWorkingDay) {
      setValue("lastWorkingDay", initialLastWorkingDay);
    }
  }, [isExactNoticeDate, initialLastWorkingDay]);

  const handleDownload = () => {
    // Extract the file extension (docx or pdf)
    // const fileExtension = filePath.split('.').pop().toLowerCase();
    const extension = fileExtension;
    const name = filePath;

    // const firstSlash = filePath?.indexOf('/')
    // const secondSlashIndex = filePath?.indexOf('/', firstSlash + 1)
    const path = filePath;
    // Handle the download for DOCX files
    if (extension === "docx" || extension === "doc") {
      const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${path}`;
      const link = document.createElement("a");
      link.href = url;
      link.download = name; // Optional: Custom file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else if (extension === "pdf") {
      const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${path}`;
      window.open(url, "_blank");
    } else {
      Snackbar("Unsupported file type.", "error");
    }
  };

  const [userDropdown, setUerDropdown] = useState([]);

  useEffect(() => {
    setUerDropdown(getDropdownDatas?.response?.userList);
  }, []);

  const tooltipMessage =
    Profile?.profile?.role === "coordinator" ||
      Profile?.profile?.role === "recruiter"
      ? `Permission denied for ${Profile?.profile?.role}`
      : null;

  const EmployeStatus = [
    {
      id: "EAV",
      label: "Employee Available",
    },
    {
      id: "ENA",
      label: "Employee Not Available",
    },
    {
      id: "ENO",
      label: "Employed (Not Open) ",
    },
    {
      id: "EOB",
      label: "Employed (On Bench)",
    },
    {
      id: "ELC",
      label: "Employed (Looking for Change)",
    },
    {
      id: "UEM",
      label: "Unemployed",
    },
  ];

  const candidateTypeList = [
    {
      id: "P",
      label: "Permanent",
    },
    {
      id: "C",
      label: "Contract",
    },
  ];

  const [searchTech, setSearchTech] = useState("")

  const handleSearchTech = (e) => {
    setSearchTech(e.target.value)
  }

  const filterTechnologies = technologyKeywords?.filter((name) =>
    name?.keywordName?.toLowerCase()?.startsWith(searchTech?.toLowerCase())
  )

  const formattedOption = (getDropdownDatas?.response?.userList || []).map((item) => ({
    ...item,
    label: (
      <span>
        {item?.userFullName}{" "}
        <span style={{ fontSize: "12px", color: "#7F56D9" }}>
          ({item?.roleName})
        </span>
      </span>
    ),
  }));

  return (
    <Grid2>
      <Grid2 className="container">
        {showLoader ? <DocumentLoader /> : ""}
        {showOverAllLoader ? <Loader /> : ""}
        <Grid2
          item
          sx={{
            display: "flex",
            alignItems: "center",
            color: "#6941C6",
            gap: "4px",
            cursor: "pointer",
            width: "40px",
            marginBottom: "20px",
          }}
          onClick={handleNavigateBack}
        >
          <ArrowBackIcon sx={{ fontSize: "17px" }} />
          <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
            Back
          </Typography>
        </Grid2>
        <Typography className="title" sx={{ marginLeft: "10%" }}>
          Add Candidate Profiles
        </Typography>
        {/* main box grid */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid2
            sx={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box className="formBox">
              <Grid2 sx={{ width: "100%" }}>
                <Typography sx={{ fontSize: "14px", color: "#414651" }}>
                  Upload Resume
                </Typography>
                <Grid2 item sx={{ flexGrow: 1 }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        border: "1px solid #E9EAEB",
                        height: "130px",
                        width: "100%",
                        borderRadius: "10px",
                      }}
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                    >
                      <input
                        type="file"
                        id="fileInput"
                        style={{ marginBottom: "15px", display: "none" }}
                        onChange={handleFileChange}
                        accept=".pdf, .doc, .docx"
                        multiple={false}
                      />
                      <label
                        htmlFor="fileInput"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <div
                          style={{
                            height: "45px",
                            width: "43px",
                            borderRadius: "10px",
                            border: "1px solid #E9EAEB",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "10px",
                          }}
                        >
                          <UploadCloudIcon />
                        </div>
                        <Typography sx={{ color: "#535862", fontSize: "14px" }}>
                          {" "}
                          <span
                            style={{
                              color: "#6941C6",
                              fontWeight: 600,
                              fontSize: "14px",
                            }}
                          >
                            {" "}
                            Click to Upload{" "}
                          </span>{" "}
                          or drag and drop
                        </Typography>
                        <Typography
                          sx={{
                            color: "#535862",
                            fontSize: "14px",
                            marginTop: "4px",
                          }}
                        >
                          PDF, DOC, DOCX
                        </Typography>
                      </label>
                    </div>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {files?.length !== 0 && (
                        <DescriptionIcon
                          sx={{
                            color: files[files?.length - 1]?.name?.endsWith(
                              "pdf"
                            )
                              ? "#F40009"
                              : "#0039a6",
                          }}
                        />
                      )}
                      <Typography sx={{ fontSize: "14px", color: "#535862" }}>
                        {files[files?.length - 1]?.name}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        width: "100%",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      {filePath !== null && files?.length === 0 && (
                        <DescriptionIcon
                          sx={{
                            color:
                              fileExtension === "pdf" ? "#F40009" : "#0039a6",
                          }}
                        />
                      )}
                      <span
                        onClick={handleDownload}
                        style={{
                          fontSize: "14px",
                          color: "#6941C6",
                          textDecoration: "none",
                          marginTop: "3px",
                          cursor: "pointer",
                        }}
                      >
                        <Tooltip
                          slotProps={{
                            tooltip: {
                              sx: {
                                backgroundColor: "#0A0D12",
                                borderRadius: "8px",
                                padding: "8px 12px",
                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                              },
                            },
                          }}
                          title={
                            fileExtension === "pdf"
                              ? "Click to Open"
                              : "Click to Download"
                          }
                        >
                          {files?.length === 0 &&
                            filePath?.substring(filePath?.lastIndexOf("/") + 1)}
                        </Tooltip>
                      </span>
                    </Box>
                  </div>
                  {/* {isNaN(editId) ?
                                        (isUploadResume ? (
                                            files.length === 0 ? (<span style={{ color: 'red', fontSize: '12px' }}>Resume is important </span>) : ('')
                                        ) : ('')

                                        ) : (
                                            filePath !== null ? ('') : (<span style={{ color: 'red', fontSize: '12px' }}>Resume is important</span>)
                                        )
                                    } */}
                </Grid2>
              </Grid2>

              {/* first 4 text field grid */}
              <Grid2
                item
                container
                sx={{
                  display: !isSmallcreen ? "flex" : "",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: !isSmallcreen ? "row" : "column",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                  rowGap={2}
                >
                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="inputlabels">
                      First Name <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Controller
                      control={control}
                      name={"firstName"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="text"
                          placeholder="Enter Name"
                          variant="outlined"
                          size="small"
                          className="textfields"
                          sx={{
                            width: "100%",
                            "& .MuiInputBase-root": {
                              fontSize: "14px", // Apply font size to input
                            },
                          }}
                        />
                      )}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors?.firstName ? errors?.firstName?.message : ""}
                    </span>
                  </Box>
                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="inputlabels">
                      Last Name <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Controller
                      control={control}
                      name={"lastName"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="text"
                          placeholder="Enter Last Name"
                          variant="outlined"
                          className="textfields"
                          size="small"
                        />
                      )}
                    />
                    {
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.lastName ? errors.lastName?.message : ""}
                      </span>
                    }
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: !isSmallcreen ? "row" : "column",
                    width: "100%",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                  rowGap={2}
                >
                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="inputlabels">
                      Contact Number <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Controller
                      control={control}
                      name={"mobile"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="text"
                          placeholder="Enter Contact Number"
                          onChange={(e) => {
                            field.onChange(e);
                            trigger("alternateNumber");
                          }}
                          variant="outlined"
                          size="small"
                          className="textfields"
                          onWheel={(e) => e.target.blur()}
                          sx={{
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                            {
                              display: "none",
                            },
                            "& input[type=number]": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                      )}
                    />
                    {
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.mobile ? errors.mobile?.message : ""}
                      </span>
                    }
                  </Box>

                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="inputlabels">
                      Alternate Number
                    </InputLabel>
                    <Controller
                      control={control}
                      name={"alternateNumber"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="number"
                          placeholder="Enter Alternate Number "
                          variant="outlined"
                          size="small"
                          className="textfields"
                          onWheel={(e) => e.target.blur()}
                          sx={{
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                            {
                              display: "none",
                            },
                          }}
                        />
                      )}
                    />
                    {
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.alternateNumber
                          ? errors.alternateNumber?.message
                          : ""}
                      </span>
                    }
                  </Box>
                </Box>
              </Grid2>

              <Grid2
                item
                container
                sx={{
                  display: !isSmallcreen ? "flex" : "",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: !isSmallcreen ? "row" : "column",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                  rowGap={2}
                >
                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="inputlabels">
                      Email <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Controller
                      control={control}
                      name={"email"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="text"
                          onChange={(e) => {
                            field.onChange(e);
                            trigger("alternateEmail");
                          }}
                          sx={{
                            width: "100%",
                            "& .MuiInputBase-root": {
                              fontSize: "14px", // Apply font size to input
                            },
                          }}
                          placeholder="Enter Email"
                          variant="outlined"
                          size="small"
                          className="textfields"
                          autoComplete="off"
                        />
                      )}
                    />
                    {
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.email ? errors.email?.message : ""}
                      </span>
                    }
                  </Box>

                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="inputlabels">
                      Alternate Email
                    </InputLabel>
                    <Controller
                      control={control}
                      name={"alternateEmail"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="text"
                          placeholder="Enter Alternate Email"
                          variant="outlined"
                          size="small"
                          className="textfields"
                          sx={{
                            width: "100%",
                            "& .MuiInputBase-root": {
                              fontSize: "14px", // Apply font size to input
                            },
                          }}
                        />
                      )}
                    />
                    {
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.alternateEmail
                          ? errors.alternateEmail?.message
                          : ""}
                      </span>
                    }
                  </Box>
                </Box>
              </Grid2>

              <Grid2
                item
                container
                sx={{
                  display: !isSmallcreen ? "flex" : "",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: !isSmallcreen ? "row" : "column",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                  rowGap={2}
                >
                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                      <InputLabel className="inputlabels" sx={{ mb: 0 }}>
                        {isExactNoticeDate ? "Last Working Date" : "Notice Period(Days)"}
                        <span style={{ color: "red" }}>*</span>
                      </InputLabel>
                    </Box>
                    {isExactNoticeDate ? (
                      <Controller
                        control={control}
                        name={"lastWorkingDay"}
                        render={({ field }) => (
                          <MuiDatePicker
                            value={field.value ? dayjs(field.value) : null}
                            onChange={(date) => field.onChange(date ? dayjs(date).format('YYYY-MM-DD') : '')}
                            slotProps={{
                              textField: {
                                placeholder: "Select Last Working Date",
                              }
                            }}
                            minDate={undefined}
                          />
                        )}
                      />
                    ) : (
                      <Controller
                        control={control}
                        name={"noticePeriodInMonths"}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            type="number"
                            sx={{
                              width: "100%",
                              "& .MuiInputBase-root": {
                                fontSize: "14px", // Apply font size to input
                              },
                              "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                              {
                                display: "none",
                              },
                            }}
                            placeholder="Enter Notice Period"
                            variant="outlined"
                            size="small"
                            className="textfields"
                            onWheel={(e) => e.target.blur()}
                          />
                        )}
                      />
                    )}
                    <Tooltip title="Check to select exact date" arrow>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          mb: 0.5,
                          marginTop: '5px',
                          fontSize: "12px",
                        }}
                      >
                        <Checkbox
                          checked={isExactNoticeDate}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            setIsExactNoticeDate(isChecked);
                            if (isChecked) {
                              setValue("noticePeriodInMonths", "");
                              clearErrors("noticePeriodInMonths");
                            } else {
                              setValue("lastWorkingDay", null);
                              clearErrors("lastWorkingDay");
                            }
                          }}
                          sx={{
                            p: 0,
                            '& .MuiSvgIcon-root': {
                              fontSize: 16,
                            },
                          }}
                        />

                        <span
                          style={{
                            color: 'black',
                            fontSize: '0.9rem',
                            fontWeight: 400,
                            cursor: 'pointer',
                          }}
                        >
                          Last working date
                        </span>
                      </Box>
                    </Tooltip>
                    {
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.noticePeriodInMonths
                          ? errors.noticePeriodInMonths?.message
                          : ""}
                      </span>
                    }
                    {
                      errors?.lastWorkingDay && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.lastWorkingDay?.message}
                        </span>
                      )
                    }
                  </Box>

                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="inputlabels">
                      Location<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Controller
                      control={control}
                      name={"address"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="text"
                          sx={{
                            width: "100%",
                            "& .MuiInputBase-root": {
                              fontSize: "14px", // Apply font size to input
                            },
                          }}
                          placeholder="Enter Location"
                          variant="outlined"
                          size="small"
                          className="textfields"
                        />
                      )}
                    />
                    {
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.address ? errors.address?.message : ""}
                      </span>
                    }
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: !isSmallcreen ? "row" : "column",
                    width: "100%",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                  rowGap={2}
                >
                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="inputlabels">
                      Total Experience
                    </InputLabel>
                    <Controller
                      control={control}
                      name={"totalExperience"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="number"
                          placeholder="Enter Total Experience"
                          sx={{
                            width: "100%",
                            "& .MuiInputBase-root": {
                              fontSize: "14px", // Apply font size to input
                            },
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                            {
                              display: "none",
                            },
                          }}
                          variant="outlined"
                          size="small"
                          className="textfields"
                          onWheel={(e) => e.target.blur()}
                        />
                      )}
                    />
                    {
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.totalExperience
                          ? errors.totalExperience?.message
                          : ""}
                      </span>
                    }
                  </Box>

                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="inputlabels">
                      Relevent Experience
                    </InputLabel>
                    <Controller
                      control={control}
                      name={"releventExperience"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          sx={{
                            width: "100%",
                            "& .MuiInputBase-root": {
                              fontSize: "14px", // Apply font size to input
                            },
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                            {
                              display: "none",
                            },
                          }}
                          placeholder="Enter Relevent Experience"
                          variant="outlined"
                          size="small"
                          className="textfields"
                          type="number"
                          onWheel={(e) => e.target.blur()}
                        />
                      )}
                    />
                    {
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.releventExperience
                          ? errors.releventExperience?.message
                          : ""}
                      </span>
                    }
                  </Box>
                </Box>
              </Grid2>

              <Grid2
                item
                container
                sx={{
                  display: !isSmallcreen ? "flex" : "",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: !isSmallcreen ? "row" : "column",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                  rowGap={2}
                >
                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="inputlabels">
                      Current Organization
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </InputLabel>
                    <Controller
                      control={control}
                      name={"currentOrganization"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="text"
                          inputProps={{
                            readOnly:
                              !!editId &&
                              role !== "admin" && role !== "coordinator" &&
                              getCandidateDetail?.response?.candidateStatus === "ENA", // 3. Candidate status is ENA
                          }}
                          sx={{
                            width: "100%",
                            "& .MuiInputBase-root": {
                              fontSize: "14px", // Apply font size to input
                            },
                          }}
                          placeholder="Enter Current Organization"
                          variant="outlined"
                          size="small"
                          className="textfields"
                        />
                      )}
                    />
                    {
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.currentOrganization
                          ? errors.currentOrganization?.message
                          : ""}
                      </span>
                    }
                  </Box>

                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="inputlabels">
                      Sourced By <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    {role === "recruiter" && id === 3 ? (
                      <TextField
                        type="text"
                        sx={{
                          width: "100%",
                          "& .MuiInputBase-root": {
                            fontSize: "14px",
                          },
                        }}
                        variant="outlined"
                        size="small"
                        className="textfields"
                        value={emailId}
                      />
                    ) : (
                      <div
                        style={{
                          display: !isSmallcreen ? "flex" : "",
                          flexDirection: "column",
                          width: "100%",
                          justifyContent: "space-between",
                        }}
                      >
                        <Controller
                          name="submittedBy"
                          control={control}
                          render={({ field }) => (
                            <Dropdown
                              {...field}
                              IconComponent={KeyboardArrowDownIcon}
                              className="dropdown"
                              placeholder="Select email"
                              displayEmpty
                              helperText={
                                errors?.submittedBy
                                  ? errors?.submittedBy?.message
                                  : ""
                              }
                              options={
                                formattedOption || []
                              }
                              valueKey="userEmail"
                              disabled={role !== "admin"}
                              labelKey="label"
                              sx={{
                                height: "35px",
                                width: "100%",
                                fontSize: "14px",
                                "& .MuiInputBase-root": {
                                  fontSize: "14px", // Apply font size to input
                                },
                              }}
                            />
                          )}
                        />
                        {errors?.submittedBy && (
                          <div style={{ color: "red", fontSize: "12px" }}>
                            {" "}
                            Email is required
                          </div>
                        )}
                      </div>
                    )}
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: !isSmallcreen ? "row" : "column",
                    width: "100%",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                  rowGap={2}
                >
                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="inputlabels">Position</InputLabel>
                    <Controller
                      name="jobPostion"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="text"
                          sx={{
                            width: "100%",
                            "& .MuiInputBase-root": {
                              fontSize: "14px", // Apply font size to input
                            },
                          }}
                          placeholder="Enter Position Name"
                          variant="outlined"
                          size="small"
                          className="textfields"
                        />
                      )}
                    />
                    {
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.jobPostion ? errors.jobPostion?.message : ""}
                      </span>
                    }
                  </Box>


                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="inputlabels">
                      Candidate Status <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <div>
                      <FormControl sx={{ width: "100%" }}>
                        <Controller
                          control={control}
                          name="candidateStatus"
                          render={({ field }) => (
                            <Select
                              {...field}
                              IconComponent={KeyboardArrowDownIcon}
                              sx={{
                                height: "35px",
                                fontSize: "14px",
                                borderRadius: "10px",
                              }}
                              displayEmpty
                              open={openCandidateStatus}
                              onOpen={() => setOpenCandidateStatus(true)}
                              onClose={() => setOpenCandidateStatus(false)}
                              readOnly={
                                role !== "admin" && role !== "coordinator" &&
                                getCandidateDetail?.response
                                  ?.candidateStatus === "ENA"
                              }
                              disabled={role === "recruiter" &&
                                getCandidateDetail?.response
                                  ?.candidateStatus === "ENA"}
                              renderValue={(selected) =>
                                selected?.length < 1 ? (
                                  <p
                                    style={{
                                      color: "#a2a2a2",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {" "}
                                    Select Candidate Status
                                  </p>
                                ) : (
                                  EmployeStatus?.filter(
                                    (item) => item?.id === selected
                                  ).map((data) => data?.label)
                                )
                              }
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <MenuItem
                                  value=""
                                  className="menuItemsPlaceholder"
                                  disabled
                                >
                                  Select Candidate Status
                                </MenuItem>
                                <Tooltip title={"Close"} arrow>
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      setOpenCandidateStatus(false);
                                    }}
                                  >
                                    <ClearIcon
                                      sx={{
                                        fontSize: "18px",
                                        color: "#a2a2a2",
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                              {(canStatus !== "ENA"
                                ? EmployeStatus?.filter((status) => status.id !== "ENA")
                                : EmployeStatus
                              ).map((status) => (
                                <MenuItem
                                  key={status?.id}
                                  value={status?.id}
                                  sx={{
                                    margin: "5px",
                                    borderRadius: "7px",
                                    fontSize: "14px",
                                  }}
                                >
                                  {status?.label}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                      </FormControl>
                    </div>
                    {
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.candidateStatus
                          ? errors.candidateStatus?.message
                          : ""}
                      </span>
                    }
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: !isSmallcreen ? "row" : "column",
                    width: "100%",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                  rowGap={2}
                >
                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="inputlabels">
                      Candidate Type <span style={{ color: "red" }}>*</span>{" "}
                    </InputLabel>
                    <Box sx={{ flex: 1 }}>
                      <Controller
                        control={control}
                        name={"candidateType"}
                        render={({ field }) => (
                          <Select
                            {...field}
                            size="small"
                            className="dropdown"
                            displayEmpty
                            open={openPostionType}
                            onOpen={() => setOpenPostionType(true)}
                            onClose={() => setOpenPostionType(false)}
                            sx={{
                              "& .MuiFormHelperText-root": {
                                color: errors?.positionType ? "red" : "inherit",
                                marginLeft: "-1px",
                              },
                              "& .MuiSelect-select.Mui-disabled": {
                                cursor: "not-allowed",
                              },
                              borderRadius: "10px",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                            renderValue={(selected) => {
                              if (!selected) {
                                return <p style={{ color: "#a2a2a2" }}>Select Candidate Type</p>;
                              } else {
                                const selectedItem = candidateTypeList?.find(
                                  (item) => item?.id === selected   // <-- match by id
                                );
                                return selectedItem ? selectedItem?.label : "";
                              }
                            }}

                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <MenuItem value="" disabled>
                                <span className="menuItemsPlaceholder">
                                  {" "}
                                  Select Candidate type{" "}
                                </span>
                              </MenuItem>
                              <Tooltip title={"Close"} arrow>
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    setOpenPostionType(false);
                                  }}
                                >
                                  <ClearIcon
                                    sx={{ fontSize: "18px", color: "#a2a2a2" }}
                                  />
                                </IconButton>
                              </Tooltip>
                            </Box>
                            {candidateTypeList?.map((option) => (
                              <MenuItem
                                className="menuitems"
                                key={option?.id}
                                value={option?.id}   // <-- store ID instead of label
                              >
                                {option?.label}
                                {field.value === option?.id && (   // <-- compare with ID
                                  <DoneIcon className="doneIcon" />
                                )}
                              </MenuItem>

                            ))}
                          </Select>
                        )}
                      />
                      {errors?.candidateType?.message && (
                        <div style={{ color: "red", fontSize: "0.7rem" }}>
                          {errors?.candidateType?.message}
                        </div>
                      )}
                    </Box>
                  </Box>

                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="inputlabels">
                      Technologies <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <div>
                      <FormControl sx={{ width: "100%" }}>
                        <Select
                          IconComponent={KeyboardArrowDownIcon}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 500,
                                minHeight: 500,
                              },
                            },
                          }}
                          sx={{
                            height: "35px",
                            fontSize: "14px",
                            borderRadius: "10px",
                          }}
                          multiple
                          value={selectedKeywordIds}
                          onChange={handleCheckboxChange}
                          onKeyDown={(e) => e.stopPropagation()}
                          displayEmpty
                          open={openTechnologies}
                          onOpen={() => setOpenTechnologies(true)}
                          onClose={() => {
                            setOpenTechnologies(false);
                            setSearchTech("");
                          }}

                          renderValue={(selected) =>
                            selected?.length < 1 ? (
                              <p
                                style={{ color: "#a2a2a2", fontSize: "14px" }}
                              >
                                Select Technologies
                              </p>
                            ) : (
                              selectedKeywords
                                ?.map((item) => item?.keywordName)
                                ?.join(", ")
                            )
                          }
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <TextField
                              type="text"
                              placeholder="Search Keywords"
                              variant="outlined"
                              className="textfields"
                              size="small"
                              fullWidth
                              onWheel={(e) => e.stopPropagation()}
                              onKeyDown={(e) => e.stopPropagation()}
                              value={searchTech}
                              onChange={handleSearchTech}
                              sx={{
                                "& input": {
                                  fontSize: "14px",
                                  padding: "6px 8px",
                                },
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "px",
                                },
                                marginLeft: '20px',
                                width: '90% !important'
                              }}
                            />
                            <Tooltip title={"Close"} arrow>
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setOpenTechnologies(false);
                                  setSearchTech("");
                                }}
                              >
                                <ClearIcon
                                  sx={{ fontSize: "18px", color: "#a2a2a2" }}
                                />
                              </IconButton>
                            </Tooltip>
                          </Box>
                          {(searchTech ? filterTechnologies : technologyKeywords)?.map((keyword) => (
                            <MenuItem
                              key={keyword?.KeywordId}
                              value={keyword?.KeywordId}
                              sx={{
                                margin: "5px",
                                borderRadius: "7px",
                                fontSize: "14px",
                              }}
                            >
                              <Checkbox
                                checked={selectedKeywordIds?.includes(keyword?.KeywordId)}
                                sx={{
                                  "& .MuiSvgIcon-root": { fontSize: 18 },
                                  padding: 0.2,
                                }}
                              />
                              {keyword?.keywordName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    {istech && (
                      <div style={{ color: "red", fontSize: "0.7rem" }}>
                        Keywords is required
                      </div>
                    )}
                  </Box>
                </Box>

              </Grid2>

              {/* Grid after Upload resume */}
              {/* <Grid2 sx={{ marginTop: '10px', display: !isSmallcreen ? "flex" : '', flexDirection: 'row', justifyContent: 'space-between' }}>

                                <Box sx={{ display: 'flex', flexDirection: 'column', width: !isSmallcreen ? "40%" : '100%' }} rowGap={2}>
                                    <Box>
                                        <InputLabel className='inputlabels'>Email <span style={{ color: 'red' }}>*</span></InputLabel>
                                        <Controller
                                            control={control}
                                            name={"email"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    type='text'
                                                    onChange={(e) => {
                                                        field.onChange(e)
                                                        trigger('alternateEmail')
                                                    }}
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiInputBase-root': {
                                                            fontSize: '14px',  // Apply font size to input
                                                        },
                                                    }}
                                                    placeholder="Enter Email"
                                                    variant="outlined"
                                                    size="small"
                                                    className='textfields'
                                                    autoComplete='off'
                                                />
                                            )}
                                        />
                                        {<span style={{ color: 'red', fontSize: '12px' }}>{errors?.email ? errors.email?.message : ""}</span>}

                                    </Box>

                                    <Box>
                                        <InputLabel className='inputlabels'>CCTC(In Lakhs) <span style={{ color: 'red' }}>*</span></InputLabel>
                                        <Controller
                                            control={control}
                                            name={"cctcInLakhs"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    type='number'
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiInputBase-root': {
                                                            fontSize: '14px',  // Apply font size to input
                                                        },
                                                    }}
                                                    placeholder="Enter CCTC"
                                                    variant="outlined"
                                                    size="small"
                                                    className='textfields'
                                                    onWheel={(e) => e.target.blur()}
                                                />
                                            )}
                                        />
                                        {<span style={{ color: 'red', fontSize: '12px' }}>{errors?.cctcInLakhs ? errors.cctcInLakhs?.message : ""}</span>}

                                    </Box>

                                    <Box >
                                        <InputLabel className='inputlabels'>Notice Period(Days) <span style={{ color: 'red' }}>*</span></InputLabel>
                                        <Controller
                                            control={control}
                                            name={"noticePeriodInMonths"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    type='number'
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiInputBase-root': {
                                                            fontSize: '14px',  // Apply font size to input
                                                        },
                                                    }}
                                                    placeholder="Enter Notice Period"
                                                    variant="outlined"
                                                    size="small"
                                                    className='textfields'
                                                    onWheel={(e) => e.target.blur()}
                                                />
                                            )}
                                        />
                                        {<span style={{ color: 'red', fontSize: '12px' }}>{errors?.noticePeriodInMonths ? errors.noticePeriodInMonths?.message : ""}</span>}

                                    </Box>

                                    <Box >
                                        <InputLabel className='inputlabels'>Total Experience</InputLabel>
                                        <Controller
                                            control={control}
                                            name={"totalExperience"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    type='number'
                                                    placeholder="Enter Total Experience"
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiInputBase-root': {
                                                            fontSize: '14px',  // Apply font size to input
                                                        },
                                                    }}
                                                    variant="outlined"
                                                    size="small"
                                                    className='textfields'
                                                    onWheel={(e) => e.target.blur()}
                                                />
                                            )}
                                        />
                                        {<span style={{ color: 'red', fontSize: '12px' }}>{errors?.totalExperience ? errors.totalExperience?.message : ""}</span>}
                                    </Box>

                                    <Box >
                                        <InputLabel className='inputlabels' >Current Organization<span style={{ color: 'red' }}>*</span></InputLabel>
                                        <Controller
                                            control={control}
                                            name={"currentOrganization"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    type='text'
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiInputBase-root': {
                                                            fontSize: '14px',  // Apply font size to input
                                                        },
                                                    }}
                                                    placeholder="Enter Current Organization"
                                                    variant="outlined"
                                                    size="small"
                                                    className='textfields'
                                                />
                                            )}
                                        />
                                        {<span style={{ color: 'red', fontSize: '12px' }}>{errors?.currentOrganization ? errors.currentOrganization?.message : ""}</span>}
                                    </Box>

                                    <Box>
                                        <InputLabel className='inputlabels' >Position</InputLabel>
                                        <Controller
                                            name="jobPostion"
                                            control={control}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    type='text'
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiInputBase-root': {
                                                            fontSize: '14px',  // Apply font size to input
                                                        },
                                                    }}
                                                    placeholder="Enter Position Name"
                                                    variant="outlined"
                                                    size="small"
                                                    className='textfields'
                                                />
                                            )}
                                        />
                                        {<span style={{ color: 'red', fontSize: '12px' }}>{errors?.jobPostion ? errors.jobPostion?.message : ""}</span>}
                                    </Box>
                                    {
                                        editId ? (
                                            <Box>
                                                <InputLabel className='inputlabels'>
                                                    Candidate Status <span style={{ color: 'red' }}>*</span>
                                                </InputLabel>
                                                <FormControl sx={{ width: "100%" }}>
                                                    <Controller
                                                        control={control}
                                                        name='candidateStatus'
                                                        render={({ field }) => (
                                                            <Select
                                                                {...field}
                                                                IconComponent={KeyboardArrowDownIcon}
                                                                sx={{ height: '35px', fontSize: '14px', borderRadius: '10px' }}
                                                                displayEmpty
                                                                renderValue={(selected) => selected?.length < 1
                                                                    ? <p style={{ color: '#a2a2a2', fontSize: '14px' }}>Select Candidate Status</p>
                                                                    : EmployeStatus?.filter((item) => item?.id === selected).map((data) => data?.label)
                                                                }

                                                            >
                                                                <MenuItem value='' className="menuItemsPlaceholder" disabled>
                                                                    Select Candidate Status
                                                                </MenuItem>
                                                                {EmployeStatus?.map((status) => (
                                                                    <MenuItem key={status?.id} value={status?.id} sx={{ margin: '5px', borderRadius: '7px', fontSize: '14px' }}>
                                                                        {status?.label}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        )}
                                                    />
                                                </FormControl>
                                                {<span style={{ color: 'red', fontSize: '12px' }}>{errors?.candidateStatus ? errors.candidateStatus?.message : ""}</span>}
                                            </Box>
                                        ) : (<></>)
                                    }


                                </Box>

                                <Box sx={{ display: 'flex', flexDirection: 'column', width: !isSmallcreen ? "40%" : '100%' }} rowGap={2}>
                                    <Box >
                                        <InputLabel className='inputlabels'>Alternate Email</InputLabel>
                                        <Controller
                                            control={control}
                                            name={"alternateEmail"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    type='text'
                                                    placeholder="Enter Alternate Email"
                                                    variant="outlined"
                                                    size="small"
                                                    className='textfields'
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiInputBase-root': {
                                                            fontSize: '14px',  // Apply font size to input
                                                        },
                                                    }}


                                                />
                                            )}
                                        />
                                        {<span style={{ color: 'red', fontSize: '12px' }}>{errors?.alternateEmail ? errors.alternateEmail?.message : ""}</span>}
                                    </Box>
                                    <Box >
                                        <InputLabel className='inputlabels'> ECTC(In Lakhs) <span style={{ color: 'red' }}>*</span></InputLabel>
                                        <Controller
                                            control={control}
                                            name={"ectcInLakhs"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    type='number'
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiInputBase-root': {
                                                            fontSize: '14px',  // Apply font size to input
                                                        },
                                                    }}
                                                    placeholder="Enter  ECTC"
                                                    variant="outlined"
                                                    size="small"
                                                    className='textfields'
                                                    onWheel={(e) => e.target.blur()}
                                                />
                                            )}
                                        />
                                        {<span style={{ color: 'red', fontSize: '12px' }}>{errors?.ectcInLakhs ? errors.ectcInLakhs?.message : ""}</span>}

                                    </Box>

                                    <Box >
                                        <InputLabel className='inputlabels'>Location<span style={{ color: 'red' }}>*</span></InputLabel>
                                        <Controller
                                            control={control}
                                            name={"address"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    type='text'
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiInputBase-root': {
                                                            fontSize: '14px',  // Apply font size to input
                                                        },
                                                    }}
                                                    placeholder="Enter Location"
                                                    variant="outlined"
                                                    size="small"
                                                    className='textfields'
                                                />
                                            )}
                                        />
                                        {<span style={{ color: 'red', fontSize: '12px' }}>{errors?.address ? errors.address?.message : ""}</span>}

                                    </Box>

                                    <Box >
                                        <InputLabel className='inputlabels'>Relevent Experience</InputLabel>
                                        <Controller
                                            control={control}
                                            name={"releventExperience"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiInputBase-root': {
                                                            fontSize: '14px',  // Apply font size to input
                                                        },
                                                    }}
                                                    placeholder="Enter Relevent Experience"
                                                    variant="outlined"
                                                    size="small"
                                                    className='textfields'
                                                    type='number'
                                                    onWheel={(e) => e.target.blur()}
                                                />
                                            )}
                                        />
                                        {<span style={{ color: 'red', fontSize: '12px' }}>{errors?.releventExperience ? errors.releventExperience?.message : ""}</span>}

                                    </Box>

                                    <Box >
                                        <InputLabel className="inputlabels" >Sourced By <span style={{ color: 'red' }}>*</span></InputLabel>
                                        {
                                            role === 'recruiter' && id === 3 ? (
                                                <TextField
                                                    type='text'
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiInputBase-root': {
                                                            fontSize: '14px',  // Apply font size to input
                                                        },
                                                    }}
                                                    variant="outlined"
                                                    size="small"
                                                    className='textfields'
                                                    value={emailId}
                                                />
                                            ) : (
                                                <div style={{ display: !isSmallcreen ? 'flex' : "", flexDirection: 'column', width: '100%', justifyContent: 'space-between' }}>
                                                    <Controller
                                                        name="submittedBy"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <Dropdown
                                                                {...field}
                                                                IconComponent={KeyboardArrowDownIcon}
                                                                className="dropdown"
                                                                placeholder="Select email"
                                                                displayEmpty
                                                                helperText={errors?.submittedBy ? errors?.submittedBy?.message : ""}
                                                                options={getDropdownDatas?.response?.userList || []}
                                                                valueKey="userEmail"
                                                                labelKey="userFullName"
                                                                sx={{
                                                                    height: '35px', width: '100%', fontSize: '14px',

                                                                    '& .MuiInputBase-root': {
                                                                        fontSize: '14px',  // Apply font size to input
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                    {errors?.submittedBy && (<div style={{ color: 'red', fontSize: '12px' }} > Email is required</div>)}
                                                </div>
                                            )
                                        }
                                    </Box>


                                    <Box>
                                        {editId ? (
                                            <Box>
                                                <InputLabel className='inputlabels'>
                                                    Technologies <span style={{ color: 'red' }}>*</span>
                                                </InputLabel>
                                                <div>
                                                    <FormControl sx={{ width: "100%" }}>
                                                        <Select
                                                            IconComponent={KeyboardArrowDownIcon}
                                                            sx={{ height: '35px', fontSize: '14px', borderRadius: '10px' }}
                                                            multiple
                                                            value={selectedKeywordIds}
                                                            onChange={handleCheckboxChange}
                                                            displayEmpty
                                                            renderValue={(selected) => selected?.length < 1
                                                                ? <p style={{ color: '#a2a2a2', fontSize: '14px' }}>Select Technologies</p>
                                                                : selectedKeywords?.map((item) => item?.keywordName)?.join(', ')
                                                            }
                                                        >
                                                            <MenuItem value='' className="menuItemsPlaceholder" disabled>
                                                                Select Technologies
                                                            </MenuItem>
                                                            {technologyKeywords?.map((keyword) => (
                                                                <MenuItem key={keyword?.KeywordId} value={keyword?.KeywordId} sx={{ margin: '5px', borderRadius: '7px', fontSize: '14px' }}>
                                                                    <Checkbox
                                                                        checked={selectedKeywordIds?.includes(keyword?.KeywordId)}
                                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 18 }, padding: 0.2 }}
                                                                    />
                                                                    {keyword?.keywordName}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </Box>
                                        ) : (
                                            <Box>
                                                <InputLabel className='inputlabels'>
                                                    Candidate Status <span style={{ color: 'red' }}>*</span>
                                                </InputLabel>
                                                <div>
                                                    <FormControl sx={{ width: "100%" }}>
                                                        <Controller
                                                            control={control}
                                                            name='candidateStatus'
                                                            render={({ field }) => (
                                                                <Select
                                                                    {...field}
                                                                    IconComponent={KeyboardArrowDownIcon}
                                                                    sx={{ height: '35px', fontSize: '14px', borderRadius: '10px' }}
                                                                    displayEmpty
                                                                    renderValue={(selected) => selected?.length < 1
                                                                        ? <p style={{ color: '#a2a2a2', fontSize: '14px' }}>   Select Candidate Status</p>
                                                                        : EmployeStatus?.filter((item) => item?.id === selected).map((data) => data?.label)
                                                                    }

                                                                >
                                                                    <MenuItem value='' className="menuItemsPlaceholder" disabled>
                                                                        Select Candidate Status
                                                                    </MenuItem>
                                                                    {EmployeStatus?.map((status) => (
                                                                        <MenuItem key={status?.id} value={status?.id} sx={{ margin: '5px', borderRadius: '7px', fontSize: '14px' }}>
                                                                            {status?.label}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            )}
                                                        />
                                                    </FormControl>
                                                </div>
                                                {<span style={{ color: 'red', fontSize: '12px' }}>{errors?.candidateStatus ? errors.candidateStatus?.message : ""}</span>}
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            </Grid2> */}

              {/* Technologies Grid */}
              {/* {!editId ? (
                <Grid2
                  item
                  container
                  sx={{ display: !isSmallcreen ? "flex" : "", width: "100%" }}
                >
                  <Box
                    item
                    sx={{
                      display: !!isSmallcreen ? "flex" : "",
                      width: "100%",
                      flexDirection: "column",
                    }}
                  >
                    <InputLabel
                      className="inputlabels"
                      sx={{ marginTop: "10px" }}
                    >
                      Technologies <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <div>
                      <FormControl sx={{ width: "100%" }}>
                        <Select
                          multiple
                          open={openSelect}
                          onOpen={() => setOpenSelect(true)}
                          onClose={() => {
                            setOpenSelect(false);
                            setSearchTech("");
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                          displayEmpty
                          value={selectedKeywordIds?.filter(
                            (id) => id !== undefined
                          )}
                          onChange={handleCheckboxChange}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 600,
                                minHeight: 600,
                              },
                            },
                          }}
                          sx={{
                            height: "35px",
                            fontSize: "14px",
                            borderRadius: "10px",
                          }}
                          renderValue={(selected) =>
                            selected?.length < 1 ? (
                              <p style={{ color: "#a2a2a2", fontSize: "14px" }}>
                                Select Technologies
                              </p>
                            ) : (
                              selectedKeywords
                                ?.map((item) => item?.keywordName)
                                ?.join(", ")
                            )
                          }
                        >
                          <Box
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <IconButton
                              size="small"
                              onClick={() => {
                                // setSelectedKeywordIds([]); // optionally clear
                                setOpenSelect(false);
                                setSearchTech("")
                              }}
                            >
                              <ClearIcon
                                sx={{ fontSize: "18px", color: "#a2a2a2" }}
                              />
                            </IconButton>
                          </Box>

                          <TextField
                            type="text"
                            placeholder="Search Keywords"
                            variant="outlined"
                            className="textfields"
                            size="small"
                            fullWidth
                            onWheel={(e) => e.stopPropagation()}
                            onKeyDown={(e) => e.stopPropagation()}
                            value={searchTech}
                            onChange={handleSearchTech}
                            sx={{
                              "& input": {
                                fontSize: "14px",
                                padding: "6px 8px",
                              },
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "px",
                              },
                              marginLeft: '20px',
                              width: '90% !important'
                            }}
                          />

                          {(searchTech ? filterTechnologies : technologyKeywords)?.map((keyword) => (
                            <MenuItem
                              key={keyword?.KeywordId}
                              value={keyword?.KeywordId}
                              sx={{
                                margin: "5px",
                                borderRadius: "7px",
                                fontSize: "14px",
                              }}
                            >
                              <Checkbox
                                checked={selectedKeywordIds?.includes(keyword?.KeywordId)}
                                sx={{
                                  "& .MuiSvgIcon-root": { fontSize: 18 },
                                  padding: 0.2,
                                }}
                              />
                              {keyword?.keywordName}
                            </MenuItem>
                          ))}
                          {searchTech && filterTechnologies?.length === 0 && (
                            <MenuItem disabled sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              No Technologies Found
                            </MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </div>
                  </Box>{" "}
                  {istech ? (
                    selectedKeywords.length <= 0 ? (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        Technologies is required
                      </span>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </Grid2>
              ) : (
                <></>
              )} */}

              {editId && statusId === "Inactive" ? (
                <Grid2
                  item
                  sx={{
                    display: !isSmallcreen ? "flex" : "",
                    marginTop: "15px",
                    width: "100%",
                    flexDirection: "column",
                  }}
                >
                  <InputLabel className="inputlabels">
                    {" "}
                    Reason For Rejection{" "}
                    <span style={{ color: "red", fontSize: "12px" }}>*</span>
                  </InputLabel>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <textarea
                      size="small"
                      style={{
                        width: "100%",
                        height: "70px",
                        fontSize: "14px",
                        paddingTop: "5px",
                        paddingLeft: "10px",
                        fontFamily: "Arial, Helvetica, sans-serif",
                        boxSizing: "border-box",
                        borderRadius: "10px",
                        border: "1px solid #ced4da",
                        resize: "none",
                      }}
                      className="textareas"
                      placeholder="Enter Reason For Reject"
                      value={reasonForReject}
                      onChange={hanldeReasonForReject}
                    />

                    {reasonError && (
                      <p style={{ color: "red", fontSize: "12px" }}>
                        Reason For Rejection is Required
                      </p>
                    )}
                  </Box>
                </Grid2>
              ) : (
                <></>
              )}


              <Box
                sx={{
                  display: "flex",
                  flexDirection: !isSmallcreen ? "row" : "column",
                  width: "100%",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
                rowGap={2}
              >
                <Box sx={{ width: !isSmallcreen ? "30%" : "100%" }}>
                  <InputLabel className="inputlabels">
                    Currency Type <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <FormControl sx={{ width: "100%" }}>
                    <Controller
                      control={control}
                      name="currencyType"
                      render={({ field }) => (
                        <Select
                          {...field}
                          IconComponent={KeyboardArrowDownIcon}
                          sx={{ height: "35px", fontSize: "14px", borderRadius: "10px" }}
                          displayEmpty
                          open={openCurrencyType}
                          onOpen={() => setOpenCurrencyType(true)}
                          onClose={() => setOpenCurrencyType(false)}
                          renderValue={(selected) =>
                            selected?.length < 1 ? (
                              <p style={{ color: "#a2a2a2", fontSize: "14px" }}>Select Currency</p>
                            ) : (
                              currencyOptions?.filter((item) => item?.id === selected).map((data) => data?.label)
                            )
                          }
                        >
                          {currencyOptions?.map((status) => (
                            <MenuItem key={status?.id} value={status?.id} sx={{ margin: "5px", borderRadius: "7px", fontSize: "14px" }}>
                              {status?.label}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                  {<span style={{ color: "red", fontSize: "12px" }}>{errors?.currencyType ? errors.currencyType?.message : ""}</span>}
                </Box>

                <Box sx={{ width: !isSmallcreen ? "30%" : "100%" }}>
                  <InputLabel className="inputlabels">
                    CCTC (In Lakhs) <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Controller
                    control={control}
                    name={"cctcInLakhs"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        type="number"
                        sx={{
                          width: "100%",
                          "& .MuiInputBase-root": {
                            fontSize: "14px", // Apply font size to input
                          },
                          "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                          {
                            display: "none",
                          },
                        }}
                        placeholder="Enter CCTC"
                        variant="outlined"
                        size="small"
                        className="textfields"
                        onWheel={(e) => e.target.blur()}
                      />
                    )}
                  />
                  {
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors?.cctcInLakhs ? errors.cctcInLakhs?.message : ""}
                    </span>
                  }
                </Box>

                <Box sx={{ width: !isSmallcreen ? "30%" : "100%" }}>
                  <InputLabel className="inputlabels">
                    {" "}
                    ECTC (In Lakhs) <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Controller
                    control={control}
                    name={"ectcInLakhs"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        type="number"
                        sx={{
                          width: "100%",
                          "& .MuiInputBase-root": {
                            fontSize: "14px", // Apply font size to input
                          },
                          "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                          {
                            display: "none",
                          },
                        }}
                        placeholder="Enter  ECTC"
                        variant="outlined"
                        size="small"
                        className="textfields"
                        onWheel={(e) => e.target.blur()}
                      />
                    )}
                  />
                  {
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors?.ectcInLakhs ? errors.ectcInLakhs?.message : ""}
                    </span>
                  }
                </Box>
              </Box>

              <Grid2
                item
                sx={{
                  display: !isSmallcreen ? "flex" : "",
                  marginTop: "15px",
                  width: "100%",
                  flexDirection: "column",
                }}
              >
                <InputLabel className="inputlabels">
                  {" "}
                  Remarks{" "}
                  <span style={{ color: "red", fontSize: "12px" }}>*</span>
                </InputLabel>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Controller
                    control={control}
                    name={"remarks"}
                    render={({ field }) => (
                      <textarea
                        {...field}
                        size="small"
                        style={{
                          width: "100%",
                          height: "70px",
                          fontSize: "14px",
                          paddingTop: "5px",
                          paddingLeft: "10px",
                          fontFamily: "Arial, Helvetica, sans-serif",
                          boxSizing: "border-box",
                          borderRadius: "10px",
                          border: "1px solid #ced4da",
                          resize: "none",
                        }}
                        className="textareas"
                        placeholder="Enter Remarks"
                      />
                    )}
                  />
                  {
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors?.remarks ? errors.remarks?.message : ""}
                    </span>
                  }
                </Box>
              </Grid2>
            </Box>
          </Grid2>

          <Grid2
            item
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "20px",
              marginTop: "30px",
            }}
          >
            <MUICancelButton
              title="Cancel"
              component={Link}
              to={isReferrals ? "/referrals" : "/candidateprofile"}
            />
            {editId ? (
              <span>
                <MUIButton
                  title="Save Changes"
                  type="submit"
                  sx={{
                    backgroundColor: "#7F56D9",
                    borderRadius: "7px",
                    width: "130px",
                  }}
                />
              </span>
            ) : (
              <MUIButton
                title="Save Changes"
                type="submit"
                sx={{
                  backgroundColor: "#7F56D9",
                  borderRadius: "7px",
                  width: "130px",
                }}
              />
            )}
          </Grid2>
        </form>
      </Grid2>
    </Grid2>
  );
};

export default AddCandidate;
